import { FC, useEffect } from "react";
import { QRCodeSVG } from "qrcode.react";
import Modal from "components/Modal";
import { formatCountdown } from "shared/utils";
import { useTelegramLink } from "../model/useTelegramLink";

import styles from "./TelegramLinkModal.module.css";

interface Props {
  onClose: () => void;
}

export const TelegramLinkModal: FC<Props> = ({ onClose }) => {
  const { phase, deepLink, secondsLeft, errorMessage, retry } =
    useTelegramLink(() => {});

  useEffect(() => {
    if (phase !== "confirmed") return;
    const timer = setTimeout(onClose, 1500);
    return () => clearTimeout(timer);
  }, [phase, onClose]);

  return (
    <Modal isOpen onClose={onClose} title="Link Telegram">
      <div className={styles.content}>
        {phase === "loading" && (
          <p className={styles.status}>Generating link...</p>
        )}

        {phase === "waiting" && deepLink && (
          <>
            <div className={styles.qr}>
              <QRCodeSVG value={deepLink} size={180} />
            </div>
            <a
              className={styles.openLink}
              href={deepLink}
              target="_blank"
              rel="noreferrer"
            >
              Open in Telegram
            </a>
            <p className={styles.hint}>
              Scan the QR code with your phone&apos;s camera app (not
              Telegram&apos;s own QR scanner), or open the link above on a
              device with Telegram installed.
            </p>
            <p className={styles.timer}>
              Expires in {formatCountdown(secondsLeft)}
            </p>
          </>
        )}

        {phase === "confirmed" && (
          <p className={styles.status}>Telegram linked successfully.</p>
        )}

        {phase === "expired" && (
          <>
            <p className={styles.status}>The link has expired.</p>
            <button
              type="button"
              className={styles.retryButton}
              onClick={retry}
            >
              Generate a new link
            </button>
          </>
        )}

        {phase === "error" && (
          <>
            <p className={styles.statusError}>{errorMessage}</p>
            <button
              type="button"
              className={styles.retryButton}
              onClick={retry}
            >
              Try again
            </button>
          </>
        )}
      </div>
    </Modal>
  );
};
